export const Config = {
  API_URL: 'https://api.infinityevcharge.com/v1',
  GOOGLE_MAPS_KEY: 'AIzaSyBa0yPphimIer5WqWyEes0Ui6qOu9MuNQE',
}
